import { render } from "./vgodownadd.vue?vue&type=template&id=16b5627a&scoped=true"
import script from "./vgodownadd.vue?vue&type=script&lang=js"
export * from "./vgodownadd.vue?vue&type=script&lang=js"

import "./vgodownadd.vue?vue&type=style&index=0&id=16b5627a&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境总后台manage.jsyinba.com/jsgeneral/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16b5627a"]])

export default __exports__